import config from '../../config';

const CRYSTAL = 'crystal';
const ELECTRIC = 'electric';
const FIRE = 'fire';
const ELEMENT_TYPES = [CRYSTAL, ELECTRIC, FIRE];
const HIT_Y_OFFSET = {
  'crystal': -264,
  'electric': -288,
  'fire': -254
};

const READY_Y = config.HEIGHT - 62;
const START_Y = config.HEIGHT + 298;

const TRIANGLE_OFFSETS = [
  { x: -85, y: -50 }, // left
  { x: 0, y: -175 }, // center
  { x: 85, y: -50 } // right
];

const SPECIAL_OFFSETS = [
  { x: -85, y: -50 }, // left
  { x: 0, y: -50 }, // center
  { x: 85, y: -50 } // right
];

const SPECIAL_ACTIVE_Y = -175;
const SPECIAL_IDLE_Y = 185;

let soundManager;

class Hero {
  constructor (gameContext) {
    this.g = gameContext;
    let g = this.g;
    this.group = g.add.group();
    this.character = {};
    this.icons = [];
    this.elements = _.clone(ELEMENT_TYPES);
    this.introCompleted = false;

    soundManager = g.scene.get('SoundManager');

    let group = this.group;

    let jet = group.create(config.CENTER_X - 106, START_Y + 55, 'jets');
    jet.play('jet-thrust');
    jet = group.create(config.CENTER_X + 101, START_Y + 55, 'jets');
    jet.play('jet-thrust');
    jet = group.create(config.CENTER_X + 246, START_Y + 55, 'jets');
    jet.play('jet-thrust');
    jet = group.create(config.CENTER_X - 250, START_Y + 55, 'jets');
    jet.play('jet-thrust');
    let platform = this.platform = group.create(config.CENTER_X, START_Y, 'hero', 'platform.png');

    // add hero characters
    _.each(this.elements, (element, i) => {
      let offset = TRIANGLE_OFFSETS[i];
      let sprite = group.create(config.CENTER_X + offset.x, platform.y + offset.y, 'hero');
      this.character[element] = sprite;
      if (i === 1) {
        sprite.setFrame(`character-${element}.png`);
      } else {
        sprite.setFrame(`icon-${element}.png`);
      }
    });

    let special = group.create(config.CENTER_X, platform.y + SPECIAL_IDLE_Y, 'hero', 'character-special.png');
    special.play('cannonbolt-spin');
    special.setVisible(false);
    special.setActive(false);
    this.character.special = special;
    let specialTrail = group.create(special.x, special.y, 'cannonbolt-trail');
    // specialTrail.setOrigin(0.5, 0.25);
    specialTrail.play('cannonbolt-trail-animate');
    specialTrail.setVisible(false);
    specialTrail.setActive(false);
    this.character.specialTrail = specialTrail;
    g.children.bringToTop(special);

    let burst = group.create(config.CENTER_X, platform.y - 150, 'hero', 'burst.png');
    burst.setScale(0.1);
    burst.setAlpha(0);
    this.burst = burst;

    // console.log('Constructor', this);
  }
  scrollIn (cb) {
    let g = this.g;
    let group = this.group;
    let children = group.getChildren();

    soundManager.playSound('elevator-start');

    g.tweens.add({
      targets: children,
      y: '-=' + 360,
      duration: 1000,
      ease: 'Sine.easeOut',
      onComplete: () => {
        if (cb) {
          cb();
        }
      }
    });
  }
  scrollOut (cb) {
    let g = this.g;
    let group = this.group;
    let children = group.getChildren();
    let platform = this.platform;
    let elements = this.elements;
    let character = this.character;
    let offsets = TRIANGLE_OFFSETS;

    soundManager.playSound('elevator-stop');

    _.each(elements, (el, i) => {
      let char = character[el];
      let offset = offsets[i];
      g.tweens.add({
        targets: char,
        x: config.CENTER_X + offset.x,
        y: platform.y + offset.y,
        duration: 100
      });
    });

    g.tweens.add({
      targets: children,
      y: '+=' + 360,
      duration: 1500,
      delay: 100,
      onComplete: () => {
        if (cb) {
          cb();
        }
      }
    });
  }
  cycle () {
    let elements = this.elements;
    let element = elements.pop();
    elements.unshift(element);
    this.burstAnimation(() => {
      this.positionCharacters();
    });
  }
  burstAnimation (cb) {
    let g = this.g;
    let burst = this.burst;
    let tl = g.tweens.createTimeline();
    burst.angle = _.random(0, 359);
    let s = soundManager.playSound('switch');
    if (s) { s.volume = 0.65; }
    tl.add({
      targets: burst,
      scaleX: 1,
      scaleY: 1,
      alpha: 1,
      ease: 'Sine.easeOut',
      duration: 100,
      onComplete: () => {
        if (cb) {
          cb();
        }
      }
    });
    tl.add({
      targets: burst,
      scaleX: 0.1,
      scaleY: 0.1,
      alpha: 0,
      ease: 'Sine.easeIn',
      duration: 100
    });
    tl.play();
  }
  positionCharacters (isSpecial = false, isReturn = false) {
    let g = this.g;
    let platform = this.platform;
    let character = this.character;
    let elements = this.elements;
    let tl;
    let offsets = isSpecial ? SPECIAL_OFFSETS : TRIANGLE_OFFSETS;

    _.each(elements, (el, i) => {
      let char = character[el];
      let offset = offsets[i];

      g.tweens.add({
        targets: char,
        x: config.CENTER_X + offset.x,
        y: platform.y + offset.y,
        duration: 100
      });

      switch (i) {
        case 0:
          char.setFrame(`icon-${el}.png`);
          break;
        case 1:
          tl = g.tweens.createTimeline();
          tl.add({
            targets: char,
            scaleX: 0.5,
            scaleY: 0.5,
            duration: 50,
            onComplete: () => {
              if (isSpecial) {
                char.setFrame(`icon-${el}.png`);
              } else {
                char.setFrame(`character-${el}.png`);
              }
            }
          });
          tl.add({
            targets: char,
            scaleX: 1,
            scaleY: 1,
            duration: 50
          });
          tl.play();
          break;
        case 2:
          tl = g.tweens.createTimeline();
          tl.add({
            targets: char,
            scaleX: isSpecial || isReturn ? 1 : 0.5,
            scaleY: isSpecial || isReturn ? 1 : 0.5,
            duration: 50,
            onComplete: () => {
              char.setFrame(`icon-${el}.png`);
            }
          });
          tl.add({
            targets: char,
            scaleX: 1,
            scaleY: 1,
            duration: 50
          });
          tl.play();
          break;
      }
    });
  }
  startSpecial () {
    let g = this.g;
    let special = this.character.special;
    let specialTrail = this.character.specialTrail;

    special.setVisible(true);
    special.setActive(true);
    specialTrail.setVisible(true);
    specialTrail.setActive(true);

    this.burstAnimation(() => {
      soundManager.playSound('power-up');
      g.tweens.add({
        targets: [special, specialTrail],
        y: READY_Y + SPECIAL_ACTIVE_Y,
        duration: 500,
        ease: 'Sine.easeOut'
      });
      this.positionCharacters(true);
    });
  }
  endSpecial (cb) {
    let g = this.g;
    let special = this.character.special;
    let specialTrail = this.character.specialTrail;

    g.tweens.add({
      targets: [special, specialTrail],
      y: READY_Y + SPECIAL_IDLE_Y,
      duration: 500,
      ease: 'Sine.easeOut',
      onComplete: () => {
        special.setVisible(false);
        special.setActive(false);
        specialTrail.setVisible(false);
        specialTrail.setActive(false);
        this.burstAnimation(() => {
          this.positionCharacters(false, true);
          if (cb) {
            cb();
          }
        });
      }
    });
  }
  get activeElement () {
    return this.elements[1];
  }
  get hitY () {
    return this.platform.y + HIT_Y_OFFSET[this.activeElement];
  }
}

export default Hero;
